import { BaseBlockModel } from '@blocksuite/store';
import { makeEmbedModel } from '../_common/embed-block-helper/index.js';
export class EmbedGithubBlockModel extends makeEmbedModel(BaseBlockModel) {
}
//# sourceMappingURL=embed-github-model.js.map